module.exports = __webpack_public_path__ + "static/media/pin.64c56c72.svg";